import { useRef } from 'react';

import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Paper from '@zenbusiness/zui/Paper';
import PropTypes from 'prop-types';
import { useReactToPrint } from 'react-to-print';

import FormInfoModal from '#client/components/FormInfoModal';
import { ActionInfoButtonsGrid } from '#client/components/Grid';
import AdditionalInfo from '#client/components/TransactionDetailModal/components/AdditionalInfo';
import DetailWrapper from '#client/components/TransactionDetailModal/components/DetailWrapper';
import useBreakpoints from '#client/hooks/useBreakpoints';
import useModalDisplayTracker from '#client/hooks/useModalDisplayTracker';

import CheckDepositDetail from './components/CheckDepositDetail';

import { PrintedBox, ButtonStyled } from './index.styles';

export default function CheckDepositDetailModal({
  amount,
  createdAt,
  type,
  estimatedCompletionDate,
  status,
  balanceAmount,
  reason,
  id,
  summary,
  dateCompleted,
  transactionId,
  isCheckDeposit,
  handleClose
}) {
  const contentRef = useRef(null);
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  const handlePrint = useReactToPrint({
    content: () => contentRef.current
  });

  useModalDisplayTracker({
    elementName: 'transactions_details_modal',
    elementText: 'transactions_details_modal',
    appPageName: 'transactions_details_modal'
  });

  return (
    <FormInfoModal
      borderRadius={isDesktop ? '16px' : '0'}
      fullScreen={!isDesktop}
      handleClose={handleClose}
      title={summary}
    >
      <DialogContent sx={{ padding: 0 }}>
        <DetailWrapper>
          <PrintedBox ref={contentRef}>
            <Paper variant="outlined">
              <CheckDepositDetail
                amount={amount}
                balanceAmount={balanceAmount}
                createdAt={createdAt}
                dateCompleted={dateCompleted}
                estimatedCompletionDate={estimatedCompletionDate}
                id={id}
                isCheckDeposit={isCheckDeposit}
                reason={reason}
                status={status}
                transactionId={transactionId}
                type={type}
              />
            </Paper>
          </PrintedBox>
          <AdditionalInfo handlePrint={handlePrint} />
        </DetailWrapper>
      </DialogContent>
      {!isDesktop && (
        <ActionInfoButtonsGrid>
          <Box>
            <ButtonStyled
              color="primary"
              onClick={handleClose}
              size="large"
              variant="text"
            >
              Close
            </ButtonStyled>
          </Box>
        </ActionInfoButtonsGrid>
      )}
    </FormInfoModal>
  );
}

CheckDepositDetailModal.propTypes = {
  amount: PropTypes.string,
  createdAt: PropTypes.string,
  type: PropTypes.string,
  estimatedCompletionDate: PropTypes.string,
  balanceAmount: PropTypes.string,
  id: PropTypes.string,
  status: PropTypes.string,
  reason: PropTypes.string,
  summary: PropTypes.string,
  dateCompleted: PropTypes.string,
  transactionId: PropTypes.string,
  isCheckDeposit: PropTypes.bool,
  handleClose: PropTypes.func
};
